<template>
  <div class="contrib-block d-flex flex-fill w-100">
    <div class="d-flex flex-column w-100">
      <div class="d-flex w-100 align-items-center mb-1">
        <div class="contrib-icon">
          <img :src="icon" />
        </div>
        <div class="contrib-title">{{ title }}</div>
      </div>
      <div class="contrib-text" v-dompurify-html="text"></div>
      <!--      <span class="contrib-source mt-auto text-right">Elaborazioni Mainstreet Partners 2019</span>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "ContribPanel",
  props: {
    title: String,
    icon: String,
    text: String
  }
};
</script>

<style scoped></style>
